import React, { useState, createContext, useEffect, useContext} from "react"

import LanguageContext from "./LanguageContext"


import APIS from "../utils/APIS"
import { isLoggedIn, getCurrentUser, setUser as setUserAuth } from "../utils/auth"

const UserAdminClientContext = createContext()


const UserAdminClientProvider = ({ children }) => {

  const {
    actLanguage,
    changeLanguage,
  } = useContext(LanguageContext)

  const [loaded, setLoaded] = useState(false)
  const [firstLoad, setFirstLoad] = useState(false)

  const [ecoles, setEcoles] = useState([])
  const [allGroupes, setAllGroupes] = useState([])
  const [actEcole, setActEcole] = useState(null)
  const [actEcoleID, setActEcoleID] = useState(null)
  /* B50 (25/09/2026) : pose UNIQUEMENT quand le chargement a conclu qu'il n'y a
     rien a montrer : 'aucuneEcole' (compte rattache a aucune ecole) ou
     'aucunGroupe' (ecole sans groupe). Un message fonde sur `actEcoleID === null`
     s'affichait a tort pour une ecole sans groupe, et clignotait chez tous les
     admins pendant le chargement (relectures du 25/09). */
  const [sansPerimetre, setSansPerimetre] = useState(null)
  const [actPage, setActPage] = useState(null)

  const [user, setUser] = useState(null)

  let defaultPage = "home"
  const getGroupeAndPage = (url) => {
    url = url.replace('/admindashboard', '')
    url = url.replace('/admindashboard/', '')
    let split = url.split('/')
    split = split.filter((el) => el !== '')

    if (split.length === 0) {
      return { id : null, page : defaultPage }
    } else if (split.length === 1) {
      return { id : parseInt(split[0]), page : defaultPage }
    } else if (split.length === 2) {
      if ((split[1] === defaultPage) || (split[1] === "suivi") || (split[1] === "progression") || (split[1] === "certification")) {
        return { id : parseInt(split[0]), page : split[1] }
      } else {
        return { id : parseInt(split[0]), page : defaultPage }
      }
    } else {
      return { id : null, page : defaultPage }
    }
  }

  useEffect(() => {
    if (actLanguage && user?.language) {
      if (actLanguage !== user?.langauge) {
        changeLanguage(user?.language)
      }
    }
  }, [actLanguage, user])


  useEffect(() => {
    if (loaded === false) {
      updateUserContext()
    }
  }, [loaded])

  const updateUserContext = (id, forceRefreshStorage) => {
    APIS.getAllInfos(id).then((result) => {
      let actUser = getCurrentUser()
      if (actUser.type === "adminclient" && result?.user?.type === 'adminclient') {
        //console.log(result)
        setUser(result?.user)
        setEcoles(result?.ecoles)
        setAllGroupes(result?.groupes)
        if (forceRefreshStorage) {
          APIS.getLoginStatus().then(result => {
            if (result?.message == "status" && result?.user) {
              setUserAuth(result?.user)
            }
          })
        }
        setLoaded(true)
      }
    })
  }

  useEffect(() => {
    let include = window.location.pathname.includes("/admindashboard")
    if (loaded === true && firstLoad === false) {
      if (allGroupes?.length > 0 && ecoles?.length > 0) {
        let groupeAndPage = getGroupeAndPage(window.location.pathname)
        let finalID = null
        let finalPage = groupeAndPage.page
        if (groupeAndPage.id === null) { //on prend la première école
          finalID = ecoles[0].ecoleID
        } else {
          let find = ecoles?.find((el) => el.ecoleID === groupeAndPage.id)
          if (find) {
            finalID = find.ecoleID
          } else {
            finalID = ecoles[0].ecoleID
          }
        }

        let findEcole = ecoles?.find((el) => el.ecoleID === finalID)
        let findAllGroupes = [...allGroupes].filter((el) => {
          if (el.ecoleID === findEcole.ecoleID) { return true } else { return false }
        })
        findAllGroupes = [...new Set(findAllGroupes)].sort((a, b) => {
          let textA = ""
          if (a.diplome) { textA = a.diplome } else { textA = a.name }
          let textB = ""
          if (b.diplome) { textB = b.diplome } else { textB = b.name }
          return textA.localeCompare(textB)
        })
        findEcole.groupes = findAllGroupes
        //on s'occupe des questions icebreaker
        let anneesReps = []
        let diplomeReps = []
        let secteursReps = []
        findEcole.groupes.forEach((g) => {
          if (g?.icebreakerQuestions?.annees === true) {
            g?.icebreakerQuestions?.anneesReps?.forEach((rep) => {
              anneesReps.push(rep)
            })
          }
          if (g?.icebreakerQuestions?.diplome === true) {
            g?.icebreakerQuestions?.diplomeReps?.forEach((rep) => {
              diplomeReps.push(rep)
            })
          }
          if (g?.icebreakerQuestions?.secteurs === true) {
            g?.icebreakerQuestions?.secteursReps?.forEach((rep) => {
              secteursReps.push(rep)
            })
          }
        })
        anneesReps = [...new Set(anneesReps)];
        diplomeReps = [...new Set(diplomeReps)];
        secteursReps = [...new Set(secteursReps)];
        findEcole.icebreakerQuestions = {
          annees : anneesReps.length > 0 ? true : false,
          anneesReps : anneesReps,
          diplome : diplomeReps.length > 0 ? true : false,
          diplomeReps : diplomeReps,
          secteurs : secteursReps.length > 0 ? true : false,
          secteursReps : secteursReps,
        }
        setActEcoleID(finalID)
        setActEcole(findEcole)

        if (finalPage === "suivi" && user?.plan?.suivi !== true) { finalPage = defaultPage }
        if (finalPage === "progression" && user?.plan?.mapping !== true) { finalPage = defaultPage }
        if (finalPage === "certification" && user?.plan?.certif !== true) { finalPage = defaultPage }
        setActPage(finalPage)

        setFirstLoad(true)

        if (include) {
          let finalURL = window.location.origin+'/admindashboard/'+finalID+'/'+finalPage
          window.history.replaceState(null, null, finalURL)
        }

      } else {
        console.log("no ecoles")
        setSansPerimetre(ecoles?.length > 0 ? 'aucunGroupe' : 'aucuneEcole')
        let finalURL = window.location.origin+'/admindashboard/'
        window.history.replaceState(null, null, finalURL)

        setFirstLoad(true)
      }
    }
  }, [loaded, firstLoad, ecoles, allGroupes, window.location.pathname, user])

  const updateActEcole = (id, page) => {
    if (allGroupes?.length > 0 && ecoles?.length > 0) {
      let groupeAndPage = getGroupeAndPage(window.location.pathname)
      let findEcole = ecoles?.find((el) => el.ecoleID === id)
      let findAllGroupes = [...allGroupes].filter((el) => {
        if (el.ecoleID === findEcole.ecoleID) { return true } else { return false }
      })
      findAllGroupes = [...new Set(findAllGroupes)].sort((a, b) => {
        let textA = ""
        if (a.diplome) { textA = a.diplome } else { textA = a.name }
        let textB = ""
        if (b.diplome) { textB = b.diplome } else { textB = b.name }
        return textA.localeCompare(textB)
      })
      findEcole.groupes = findAllGroupes
      //on s'occupe des questions icebreaker
      let anneesReps = []
      let diplomeReps = []
      let secteursReps = []
      findEcole.groupes.forEach((g) => {
        if (g?.icebreakerQuestions?.annees === true) {
          g?.icebreakerQuestions?.anneesReps?.forEach((rep) => {
            anneesReps.push(rep)
          })
        }
        if (g?.icebreakerQuestions?.diplome === true) {
          g?.icebreakerQuestions?.diplomeReps?.forEach((rep) => {
            diplomeReps.push(rep)
          })
        }
        if (g?.icebreakerQuestions?.secteurs === true) {
          g?.icebreakerQuestions?.secteursReps?.forEach((rep) => {
            secteursReps.push(rep)
          })
        }
      })
      anneesReps = [...new Set(anneesReps)];
      diplomeReps = [...new Set(diplomeReps)];
      secteursReps = [...new Set(secteursReps)];
      findEcole.icebreakerQuestions = {
        annees : anneesReps.length > 0 ? true : false,
        anneesReps : anneesReps,
        diplome : diplomeReps.length > 0 ? true : false,
        diplomeReps : diplomeReps,
        secteurs : secteursReps.length > 0 ? true : false,
        secteursReps : secteursReps,
      }
      if (findEcole) {
        groupeAndPage.id = id
        setActEcoleID(id)
        setActEcole(findEcole)
      } else {
        let findAllGroupes = [...allGroupes].filter((el) => {
          if (el.ecoleID === ecoles[0].ecoleID) { return true } else { return false }
        })
        findAllGroupes = [...new Set(findAllGroupes)].sort((a, b) => {
          let textA = ""
          if (a.diplome) { textA = a.diplome } else { textA = a.name }
          let textB = ""
          if (b.diplome) { textB = b.diplome } else { textB = b.name }
          return textA.localeCompare(textB)
        })
        let actGroupe = {...ecoles[0]}
        actGroupe.groupes = findAllGroupes
        groupeAndPage.id = ecoles[0].ecoleID
        setActEcoleID(ecoles[0].ecoleID)
        setActEcole(actGroupe)
      }

      if (page) {
        let finalPage = page
        if (finalPage === "suivi" && user?.plan?.suivi !== true) { finalPage = defaultPage }
        if (finalPage === "progression" && user?.plan?.mapping !== true) { finalPage = defaultPage }
        if (finalPage === "certification" && user?.plan?.certif !== true) { finalPage = defaultPage }
        groupeAndPage.page = finalPage
        setActPage(groupeAndPage.page)
      }

      let finalURL = window.location.origin+'/admindashboard/'+groupeAndPage.id+'/'+groupeAndPage.page
      window.history.replaceState(null, null, finalURL)
    }
  }


  return (
    <UserAdminClientContext.Provider
      value={{
        updateUserContext,
        userLoaded : loaded,
        ecoles,
        actPage,
        actEcole,
        actEcoleID,
        sansPerimetre,
        updateActEcole,
        currentUser : user,
      }}
    >
      {children}
    </UserAdminClientContext.Provider>
  )
}

export default UserAdminClientContext

export { UserAdminClientProvider }
